import { productList } from './tableColumns'
import {
	Availability,
	CashRegisters,
	Concepts,
	LoyaltyCard,
	Hardware,
	Ingredients,
	Lists,
	Options,
	Presentation,
	Price,
	Product,
	Restaurant,
	Selection,
	Group,
	SelfCheckout,
	ClickCollect,
	ContentTranslations
} from './'
import FilterComponent from './fragments/FilterOptions'
import { updateProduct, createProduct, updateManyProducts } from './gql/mutation/'
import { getProduct, getProduct_Ingrs, getProduct_Concepts, listProducts, getProduct_Restaurant } from './gql/query'
import { getProduct_Sets } from './gql/query/getProduct'
import { ReactComponent as Baguette } from 'media/icons/baguette.svg'
import { History, Calculator } from 'media/icons'
import { INIT_QUERY_PARAMS } from 'config/consts'
import HistoryModal from 'components/HistoryModal'
import { listCategories } from 'sections/category/gql'
import { listSalesGroups, loadAppConstants } from 'gql/query'
import { isRouteDisabled } from 'sections/utils'
import GridView from './GridView'
import AutomaticPrice from './pages/AutomaticCalculation/AutomaticPrice'


const hideInGroupped = (data, { location, isNewRecord }) => location?.isCategoryLink || data?.checkOutCommandId === '600'

export default (t, rights, i18n) => ({
	id: '3',
	label: t('product_section.caption'),
	typename: 'Product',
	link: isRouteDisabled(rights, '3') ? null : 'artikel',
	linkDisabled: isRouteDisabled(rights, '3'),
	icon: Baguette,
	requiredFields: ['name', 'code'],
	recordsCounter: true,
	// uniqueFields: ['code'],
	uniqueFields: ['EANCode'],
	fieldsInLabel: [
		{ field: 'FA_ProductId', label: t('product_section.strings.product_from_FA') },
		{ field: 'RA_Recipe', label: t('product_section.strings.product_from_RA') }
	],
	multiEditConfig: [
		{
			fieldName: 'isActive',
			type: 'checkbox',
			label: t('product_section.fields.active')
		},
		{
			fieldName: 'isNetto',
			type: 'checkbox',
			label: t('product_section.fields.customer_net_product')
		},
		{
			fieldName: 'isNettoForUser',
			type: 'checkbox',
			label: t('product_section.fields.empoloyee_net_product')
		},
		{
			fieldName: 'isEmployeeArticle',
			type: 'checkbox',
			label: t('product_section.fields.empoloyee_meals')
		},
		{
			fieldName: 'category',
			queryOptions: {
				query: listCategories
			},
			type: 'simpleSelect',
			label: t('product_section.fields.category')
		},
		{
			fieldName: 'salesGroupId',
			queryOptions: {
				query: listSalesGroups
			},
			type: 'select',
			label: t('product_section.fields.sales_group')
		},
		{
			fieldName: 'unitSellCode',
			queryOptions: {
				query: loadAppConstants,
				variables: { type: 34, language: i18n.language }
			},
			type: 'selectWithoutAdditionalField',
			label: t('product_section.fields.sales_unit')
		}
	],
	subsections: [{
		name: t('product_section.sub_sections.product'),
		link: '',
		component: Product,
		updateMutation: updateProduct.product,
		fields: [
			'code', 'isActive', 'name', 'altName',
			'categoryId', 'salesGroupId', 'unitSellCode',
			'isNetto', 'isNettoForUser', 'isEmployeeArticle',
			'price', 'priceInCafe', 'codeMWSt', 'codeMWSt2', 'shopId', {
				fieldName: 'FA_ProductId',
				noForm: true
			}, {
				fieldName: 'category',
				children: ['id', 'name', '__typename']
			}
		],
		isHidden: hideInGroupped
	}, {
		name: t('product_section.sub_sections.group'),
		link: 'gruppe',
		component: Group,
		updateMutation: updateProduct.product,
		fields: [
			'code', 'isActive', 'name', 'altName',
			'categoryId', 'salesGroupId', 'nestedCategoryId', 'shopId', {
				fieldName: 'category',
				children: ['id', 'name', '__typename']
			}
		],
		isHidden: (...args) => !hideInGroupped(...args)
	}, {
		name: t('common.strings.cash_register_subsection'),
		link: 'kasse',
		component: CashRegisters,
		updateMutation: updateProduct.cashRegisters,
		fields: ['cashRegisterId']
	}, {
		name: t('product_section.sub_sections.price'),
		link: 'preise',
		component: Price,
		fields: ['specialPrices'],
		isHidden: hideInGroupped
	}, {
		name: t('product_section.sub_sections.sets'),
		link: 'auswahl',
		component: Selection,
		subsectionQuery: getProduct_Sets,
		updateMutation: updateProduct.setsInfo,
		fields: [
			'sets', 'priceDiffMode', 'setsMode', 'fixProductsAutoSelect', 'isPricesNormalByDefaultInSet', 'isMenuName'
			// 'printChosenSubProductsFlag', 'isFastSelection', 'isForTasting'
			// 'printChosenSubProducts', {
			// 	fieldName: 'category',
			// 	noForm: true
			// }
		],
		isHidden: hideInGroupped
	}, {
		name: t('product_section.sub_sections.hardware'),
		link: 'hardware',
		component: Hardware,
		updateMutation: updateProduct.hardware,
		fields: [
			'isWeighted',
			'isTareInLabelMode',
			'tare',
			'EANCode'
			// 'EANstatistics'
		],
		isHidden: hideInGroupped
	}, {
		name: t('product_section.sub_sections.restaurant'),
		link: 'restaurant',
		component: Restaurant,
		subsectionQuery: getProduct_Restaurant,
		updateMutation: updateProduct.restaurant,
		fields: [
			// { fieldName: 'properties', children: ['KitchenReportOnlyOverMenu'] },
			'isPrintOnlyInCafe', 'isAdditionRequired', 'isKitchenInfo', //'isKitchenSplit', 'isScreenKeyboard',
			//  'ordermanListName', 'isOrdermanKitchenAmount', 'isServiceCallOrderman', 'printReceipt','serviceCallPrinters',
			'isServiceCall', 'printerLocations',
			{ fieldName: 'additions', children: ['id', 'productAddionId', 'mod_ver'] }
		],
		isHidden: hideInGroupped
	}, {
		name: t('product_section.sub_sections.ingredients'),
		link: 'zutaten',
		component: Ingredients,
		updateMutation: updateProduct.ingredients,
		subsectionQuery: getProduct_Ingrs,
		fields: [
			'description', 'mustBeKeptCool', 'storage', 'weight', 'sellUp', 'shelfLife', 'daysToConsume',
			'consumptionInfo', 'application', 'altLabel', 'RA_RecipeId', 'linkLabelGroup'
		],
		isHidden: hideInGroupped
	}, {
		name: t('product_section.sub_sections.options'),
		link: 'optionen',
		component: Options,
		updateMutation: updateProduct.options,
		fields: [
			'linkExpense', 'halfNotAllowed', 'waste', 'isWarehouse', 'checkOutCommandId', 'group1Id', 'group2Id', 'group3Id'
		],
		isHidden: hideInGroupped
	}, {
		name: t('product_section.sub_sections.presentation'),
		link: 'darstellung',
		component: Presentation,
		fields: ['img', 'imgKiosk', {
			fieldName: 'properties',
			children: ['Color', 'ColorFont', 'Font', 'FontStyle', 'FontSize', 'SCOProductTimeSlot']
		}]
	}, {
		name: t('product_section.sub_sections.list'),
		link: 'liste',
		component: Lists,
		updateMutation: updateProduct.lists,
		fields: [{
			fieldName: 'lists',
			children: ['id', 'productListId']
		}],
		isHidden: hideInGroupped
	}, {
		name: t('product_section.sub_sections.loyalty_card'),
		link: 'kundenkarte',
		component: LoyaltyCard,
		updateMutation: updateProduct.loyaltyCard,
		fields: [
			'cardSurchargePercent', 'cardSurchargeFrom', 'discount',
			'pointsCost', 'pointsPriceLevel', 'cardChargeAmount',
			{ fieldName: 'points', children: ['type', 'quantity', 'points'] }
		],
		isHidden: hideInGroupped
	}, {
		name: t('product_section.sub_sections.availability'),
		link: 'vefügbarkeit',
		component: Availability,
		updateMutation: updateProduct.availability,
		fields: [
			'nameInOrder', 'inventoryUnit', 'orderUnit', 'numberPerUnit', 'minOrder',
			'isInventory', 'isForTasting', 'canCopy', 'visibleStatus', 'bakeryReturn',
			'bakeryReturnEndOfDay', 'bakeryStock', 'visibleStatus',
			'bakeryReturn', 'bakeryReturnEndOfDay', 'bakeryStock', {
				fieldName: 'intervals',
				noForm: true
			}, {
				fieldName: 'properties',
				children: ['SCOProductTimeSlot']
			}
		],
		isHidden: hideInGroupped
	}, {
		name: t('product_section.sub_sections.concept'),
		link: 'konzepte',
		component: Concepts,
		subsectionQuery: getProduct_Concepts,
		updateMutation: updateProduct.concepts,
		fields: [
			{
				fieldName: 'concepts',
				children: ['dbIndex', 'name', 'productName', 'nameInOrder', 'prices',
					'buttonCaption', 'application']
			}
		]
	}, {
		name: t('product_section.categories.self_checkout'),
		link: 'self-checkout',
		component: SelfCheckout,
		fields: [{
			fieldName: 'properties',
			children: ['SCOFoodTray', 'SCOKitchenComponent']
		}]
	},
	{
		name: t('product_section.sub_sections.clickcollect'),
		link: 'clickcollect',
		component: ClickCollect,
		fields: [{
			fieldName: 'properties',
			children: ['ClickCollectOrderMin', 'ClickCollectOrderMax', 'ClickCollectLeadDaysCount']
		}]
	},
	{
		name: t('common.strings.contentTranslations'),
		link: 'content-translations',
		component: ContentTranslations,
	},
	{
		link: 'grid',
		component: GridView,
		hideInNav: true,
		overrideHandler: true
	}, {
		link: 'automatische_preisanpassung',
		component: AutomaticPrice,
		hideInNav: true,
		overrideHandler: true
	}],
	itemActions: [{
		label: t('product_section.strings.product_inner_category'),
		action: ({ addNewRecord: { startNewRecord }, history }) => history.push({
			pathname: '/artikel/gruppe/neue',
			isCategoryLink: true
		})
	}, {
		label: t('product_section.strings.update_group'),
		action: ({ multiEdit, data }) => multiEdit.setIsActive(!multiEdit.isActive, data.id)
	}, {
		label: t('common.strings.history'),
		Icon: History,
		modalComponent: HistoryModal
	}, {
		label: t('common.strings.grid_view'),
		action: ({ history, recordId }) => history.push({
			pathname: `/artikel/grid${recordId ? '/' + recordId : ''}`
		})
	}, {
		label: t('common.strings.automatic_price_adjustment'),
		Icon: Calculator,
		action: ({ history, recordId }) => history.push({
			pathname: `/artikel/automatische_preisanpassung${recordId ? '/' + recordId : ''}`
		})
	}],
	columns: productList,
	listQuery: listProducts,
	itemQuery: getProduct,
	createMutation: createProduct,
	addNewRecord: true,
	FilterComponent,
	multiEditMutation: updateManyProducts,
	contextTypes: {
		searchCR: 'string'
	},
	newRecordsDefaults: {
		isActive: true,
		codeMWSt: 'normal',
		codeMWSt2: 'normal',
		unitSellCode: 1
	},
	initialQueryVariables: {
		filter: {
			isActive: true,
			includeWawiProducts: true,
			includeCashassistProducts: true
		},
		params: { ...INIT_QUERY_PARAMS.defaultParams, offset: 0 }
	},
	sideListProps: {
		datatableProps: {
			defaultSorted: [{
				id: 'code'
			}]
		}
	},
	gridView: GridView
	// handler: ProductHandler
})
